import React from 'react';
import { useFormContext } from 'contexts/FormContext';

/**
 * Renders a file input component with a custom label.
 *
 * @param {Object} props - The component's props.
 * @param {string} props.label - The file input's label text.
 * @param {string} props.id - The file input's id attribute.
 * @returns {React.Component} The FileInput component.
 */
const FileInput = ({ label, id }) => {
  const { handleFileInputChange, data, errors } = useFormContext();

  return (
    <>
      <label htmlFor={id} className='custom-file-input'>
        {label}
      </label>
      <input
        id={id}
        type='file'
        multiple
        className='file-input'
        onChange={handleFileInputChange}
      />
      
      {data.images && data.images.length > 0 ? (
        <p>
          {data.images.length} afbeelding
          {data.images.length > 1 ? 'en' : undefined}
        </p>
      ) : undefined}
      <p className='error'>{errors[id]}</p>
    </>
  );
};

export default FileInput;
